import { Spacer } from "@hackthenorth/north";
import { Label, Button } from "north.js";
import React from "react";

import { ExternalLink } from "src/static/icons";
import {
  PerkStatus,
  SponsorPerksData,
  SponsorPerkType,
} from "src/views/sponsor/perks/types";

import { PerkContainer, PerkTextArea } from "../components";
import Header from "../Header";
import { getPerkStatusLabel, perkStatusToBadgeColor } from "../helpers";
import { TextDescription } from "../TextComponents";
import { PerkData } from "../usePerkState";

export const WELCOME_BOOKLET_BLURB_VALIDATION_FIELDS: (keyof SponsorPerksData)[] =
  ["welcome_booklet_blurb_description"];

export const WelcomeBookletBlurb: React.FC<PerkData> = ({
  getState,
  updateState,
  isReadOnly,
  error,
}) => {
  return (
    <>
      <Header
        title="Welcome Booklet Blurb"
        subtitle="This perk is for information that will be displayed in our welcome booklet."
        badge={
          <Label
            color={perkStatusToBadgeColor(
              getState("welcome_booklet_blurb_status") as PerkStatus | undefined
            )}
            size="sm"
          >
            {getPerkStatusLabel(
              getState("welcome_booklet_blurb_status") as PerkStatus | undefined
            )}
          </Label>
        }
      />
      <PerkContainer
        description={<Description />}
        id={SponsorPerkType.WELCOME_BOOKLET_BLURB}
        readOnly={isReadOnly}
      >
        <PerkTextArea
          title="Description* (max 100 words)"
          value={getState("welcome_booklet_blurb_description") ?? ""}
          placeholder="Share a message with hackers"
          wordLimit={100}
          isReadOnly={isReadOnly}
          onChange={(e) =>
            updateState("welcome_booklet_blurb_description", e.target.value)
          }
          error={
            error?.welcome_booklet_blurb_description && (
              <>This field is required</>
            )
          }
        />
      </PerkContainer>
      <Spacer />
      <Button
        leadingIcon={<ExternalLink />}
        color="primary"
        onClick={() =>
          window.open("https://hackthenorth.com/welcome-booklet.pdf", "_blank")
        }
      >
        2026 Welcome Booklet
      </Button>
    </>
  );
};

const Description = () => (
  <TextDescription>
    We&apos;d like to feature you in our welcome booklet! Please enter a short
    description about your company for hackers to read in our welcome booklet.
  </TextDescription>
);
